import type { GenericIngredientFragment } from "../gql/generated/graphqlSchema.tsx";

export const genericIngredientLocalizedName = (gi: GenericIngredientFragment, language: string) =>
  language === "bg" ? gi.nameBg : language === "fr" ? gi.nameFr : gi.nameEn;

export const genericIngredientLocalizedBaseName = (gi: GenericIngredientFragment, language: string) =>
  language === "bg" ? gi.baseNameBg : language === "fr" ? gi.baseNameFr : gi.baseNameEn;

export const genericIngredientLocalizedProperties = (gi: GenericIngredientFragment, language: string) =>
  language === "bg" ? gi.propertiesBg : language === "fr" ? gi.propertiesFr : gi.propertiesEn;

export const foodCategoryLocalizedName = (fc: GenericIngredientFragment["foodCategory"], language: string) => {
  if (fc == null) return null;
  return language === "bg" ? fc.nameBg : language === "fr" ? fc.nameFr : fc.nameEn;
};

/** Full display name: base name + properties, falling back to the original name_xx column. */
export const genericIngredientDisplayName = (gi: GenericIngredientFragment, language: string): string => {
  const baseName = genericIngredientLocalizedBaseName(gi, language);
  const props = genericIngredientLocalizedProperties(gi, language);
  if (baseName != null) {
    return props ? `${baseName}, ${props}` : baseName;
  }
  return genericIngredientLocalizedName(gi, language);
};
